import { render } from "./Customization.vue?vue&type=template&id=53f6c305"
import script from "./Customization.vue?vue&type=script&lang=ts"
export * from "./Customization.vue?vue&type=script&lang=ts"
script.render = render

export default script